import H from 'constants/httpMethod.const';
import { fromDtoToSalonTaxesAndFees } from 'dto/salon/fromDtoToSalonTaxesAndFees.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beGetSalonTaxesAndFees = actionEndpointBe('beGetSalonTaxesAndFees', H.get, 'sales/salon/:salonId/taxes-and-fees/', {
  inert: false,
  fromDto: fromDtoToSalonTaxesAndFees,
});
